import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const initializeSwiperMidia = () => {
    document.addEventListener("DOMContentLoaded", function () {
        const swiper = new Swiper(".swiper-midia", {
            slidesPerView: 3,
            spaceBetween: 10,
            speed: 600,
            loop: false,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                480: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 }
            }
        });
    });
};

export default initializeSwiperMidia;